import React from "react";
import { useField } from "formik";
import { Box, Checkbox, FormControlLabel } from "@mui/material";

interface IFormikPreviewCheckboxWithLabelProps {
  label: React.ReactNode;
  name: string;
  color?: "primary";
  labelId?: string;
}

/**
 * @deprecated Use FormikCheckboxField instead
 */
export const FormikPreviewCheckboxWithLabel: React.FC<
  IFormikPreviewCheckboxWithLabelProps
> = ({ label, name, color, labelId }) => {
  const [field, , helpers] = useField({ name });
  return (
    <FormControlLabel
      sx={{ alignItems: "flex-start" }}
      // checkbox and label should be top aligned
      label={<Box sx={{ pt: 1 }}>{label}</Box>}
      id={labelId}
      control={
        <Checkbox
          checked={field.value == "true"}
          data-cy={name}
          onChange={(e) =>
            helpers.setValue(e.target.checked ? "true" : "false")
          }
          color={color}
          aria-labelledby={labelId}
        />
      }
    />
  );
};
